import BaseHttp from 'src/commons/store/BaseHttp'
import { API_URL, HttpSuccessType1, HttpSuccessType2 } from 'src/commons/utils/Commons'
import DealWithHttp from 'src/commons/store/DealWithHttp'
import MobXHttp from 'src/commons/store/MobXHttp'

/*#region 获取游戏帮助*/
const getGameHelp = BaseHttp<{ gameId: number }, ApiResult2<TGameHelpConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/user/game/start/help`,
})
export const DWgetGameHelp = DealWithHttp(getGameHelp, HttpSuccessType2)

export const getGameHelpHS = MobXHttp(DWgetGameHelp)

/*#region 获取9+1活动拆过的礼包*/
const getExtractGiftsHttp = BaseHttp<{ activityNo: string }, ApiResult2<GameList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/drawnGames`,
})
export const DWGetExtractGiftsHttp = DealWithHttp(getExtractGiftsHttp, HttpSuccessType2)

export const GetExtractGiftsHttpHS = MobXHttp(DWGetExtractGiftsHttp)

/*#region 获取9+1活动每次抽取的9个游戏*/
const getExtractGameHttp = BaseHttp<{ activityNo: string }, ApiResult2<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/drawGame`,
})
export const DWGetExtractGameHttp = DealWithHttp(getExtractGameHttp, HttpSuccessType2)

export const GetExtractGameHttpHS = MobXHttp(DWGetExtractGameHttp)

/*#region 获取vip活动相关信息*/
const getVipActivityInfoHttp = BaseHttp<{ activityNo: string }, ApiResult2<VipActivityConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getVipActivityInfo`,
})

export const DWGetVipActivityInfo = DealWithHttp(getVipActivityInfoHttp, HttpSuccessType2)

export const getVipActivityInfoHS = MobXHttp(DWGetVipActivityInfo)

/*#region 游戏详情*/
const GameDetailHttp = BaseHttp<TarchiveInfoHttp, ApiResult<GameDetail>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/gameDivision`,
})

export const DWGameDetailHttp = DealWithHttp(GameDetailHttp, HttpSuccessType1)

export const GameDetailHS = MobXHttp(DWGameDetailHttp)
/*#endregion*/

/*#region gameLibraryId 查询游戏详情*/
const GameDetailByGameLibraryHttp = BaseHttp<{ id: string }, ApiResult2<GameDetailByLibrary>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/game/library/detail/get`,
})

export const DWGameDetailByGameLibrary = DealWithHttp(GameDetailByGameLibraryHttp, HttpSuccessType2)

export const GameDetailByGameLibraryHttpHS = MobXHttp(DWGameDetailByGameLibrary)
/*#endregion*/

/*#region gameLibraryId 想玩游戏点击上报接口*/
const gameLibraryWantPlay = BaseHttp<{ gameLibraryId: string }, ApiResult2<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/gameLibrary/want/play`,
})

export const DWgameLibraryWantPlay = DealWithHttp(gameLibraryWantPlay, HttpSuccessType2)

export const gameLibraryWantPlayHS = MobXHttp(DWgameLibraryWantPlay)
/*#endregion*/

/*#region 商城点击添加游戏*/
const AddGameHttp = BaseHttp<AddGameQuery, ApiResult<{ to: 'game' | 'view' }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/addGame`,
})

export const DWAddGameHttp = DealWithHttp(AddGameHttp, HttpSuccessType1)
/*#endregion*/

/*#region 用户最近浏览的游戏*/
const UserViewLogHttp = BaseHttp<LoginBaseQuery, ApiResult<UserViewLog[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/myViewLog`,
})

export const DWUserViewLogHttp = DealWithHttp(UserViewLogHttp, HttpSuccessType1)
/*#endregion*/

/*#region 启动游戏*/
const StartGameHttp = BaseHttp<StartGameQuery, ApiResult<TStartGameHttp>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/startGpGame`,
})

const DWStartGameHttp = DealWithHttp(StartGameHttp, HttpSuccessType1)

export const StartGameHS = MobXHttp(DWStartGameHttp)
/*#endregion*/

/*#region 我的游戏*/
const MyGameListHttp = BaseHttp<MyGameListQuery, ApiResult<MyGame[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/myGame`,
})
// const MyGameListHttp = BaseHttp<MyGameListQuery, ApiResult<MyGame[]>>({ Type: 'Get', Url: `${API_URL.BOX}/api/myGame` })

const DWMyGameListHttp = DealWithHttp<MyGameListQuery, ApiResult<MyGame[]>, MyGame[]>(MyGameListHttp, HttpSuccessType1)

export const MyGameListHS = MobXHttp<MyGameListQuery, MyGame[], null>(DWMyGameListHttp)
/*#endregion*/

/*#region 查询支持换购的我的游戏列表*/
const myReplaceGameList = BaseHttp<MyGameListQuery, ApiResult2<MyReplaceGame[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/myShareGame`,
})

const DWmyReplaceGameListHttp = DealWithHttp<MyGameListQuery, ApiResult2<MyReplaceGame[]>, MyReplaceGame[]>(
  myReplaceGameList,
  HttpSuccessType2,
)

export const myReplaceGameListHS = MobXHttp<MyGameListQuery, MyReplaceGame[], null>(DWmyReplaceGameListHttp)
/*#endregion*/

/*#region 首页搜索*/
const SearchListHttp = BaseHttp<GameListQuery, ApiResult2<HomeSearchResult>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/anon/searchGameList`,
})

export const DWSearchListHttp = DealWithHttp<GameListQuery, ApiResult2<HomeSearchResult>, HomeSearchResult>(
  SearchListHttp,
  HttpSuccessType2,
)

export const SearchListHS = MobXHttp<GameListQuery, HomeSearchResult, null>(DWSearchListHttp)

/*#region 商品列表*/
const GameListHttp = BaseHttp<GameListQuery, ApiResult<PageResult<GameList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/gpGameList`,
})

export const DWGameListHttp = DealWithHttp<GameListQuery, ApiResult<PageResult<GameList>>, PageResult<GameList>>(
  GameListHttp,
  HttpSuccessType1,
)

export const GameListHS = MobXHttp<GameListQuery, PageResult<GameList>, null>(DWGameListHttp)
/*#endregion*/

/*#region 获取商品详情 */
const getGoodsDetail = BaseHttp<TNewGameDetailQuery, ApiResult2<GameDetail>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/goods/detail`,
})

const DWgetGoodsDetail = DealWithHttp(getGoodsDetail, HttpSuccessType2)

export const getGoodsDetailHS = MobXHttp(DWgetGoodsDetail)
/*#endregion*/

/*#region 查询专享购商品列表*/
const memberPaidSharing = BaseHttp<GameListQuery, ApiResult2<PageResult<GameList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/anon/goods/list/memberPaidSharing`,
})

export const memberPaidSharingHttp = DealWithHttp<
  GameListQuery,
  ApiResult2<PageResult<GameList>>,
  PageResult<GameList>
>(memberPaidSharing, HttpSuccessType2)

export const memberPaidSharingHS = MobXHttp<GameListQuery, PageResult<GameList>, null>(memberPaidSharingHttp)
/*#endregion*/

/*#region 获取不同价格区间的商品占比*/
const areaGoodsPriceInfo = BaseHttp<{}, ApiResult3<TAreaGoodsPriceInfo[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/anon/price/area/goods/info/get`,
})
export const loadAreaGoodsPriceInfo = DealWithHttp(areaGoodsPriceInfo, HttpSuccessType2)
/*#endregion*/

/*#region 根据游戏单品ID获取所属游戏库的存档商品列表*/
const getGamelibraryArchivesList = BaseHttp<{ goodsId: number }, ApiResult3<TGamelibraryArchives[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/anon/gamelibrary/archives/goods/get/by/goodsid`,
})

export const DWgetGamelibraryArchivesList = DealWithHttp(getGamelibraryArchivesList, HttpSuccessType2)

export const getGamelibraryArchivesListHS = MobXHttp(DWgetGamelibraryArchivesList)
/*#endregion*/

/*#region 根据游戏库ID获取所属游戏库的存档商品列表*/
const getArchivesListByGameLibraryId = BaseHttp<{ gameLibraryId: number }, ApiResult3<TGamelibraryArchives[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/anon/gamelibrary/archives/goods/get/by/gamelibraryid`,
})

export const DWgetArchivesListByGameLibraryId = DealWithHttp(getArchivesListByGameLibraryId, HttpSuccessType2)

export const getArchivesListByGameLibraryIdHS = MobXHttp(DWgetArchivesListByGameLibraryId)
/*#endregion*/

/*#region 判断用户是否有该存档商品对应的可玩的游戏*/
const checkArchiveHasPlayGame = BaseHttp<{ goodsId: number }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/archive/goods/has/playgame`,
})

export const DWcheckArchiveHasPlayGame = DealWithHttp(checkArchiveHasPlayGame, HttpSuccessType2)

export const checkArchiveHasPlayGameHS = MobXHttp(DWcheckArchiveHasPlayGame)
/*#endregion*/

/*#region 商品列表*/
const pubgGameListHttp = BaseHttp<GameListQuery, ApiResult<PageResult<GameList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/gpGameList`,
})

const DWpubgGameListHttp = DealWithHttp<GameListQuery, ApiResult<PageResult<GameList>>, PageResult<GameList>>(
  pubgGameListHttp,
  HttpSuccessType1,
)

export const pubgGameListHS = MobXHttp<GameListQuery, PageResult<GameList>, null>(DWpubgGameListHttp)
/*#endregion*/

/*#region 人气排行*/
const GameRankListHttp = BaseHttp<GameListQuery, ApiResult<PageResult<GameList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/gpGameList`,
})

const DWGameRankListHttp = DealWithHttp<GameListQuery, ApiResult<PageResult<GameList>>, PageResult<GameList>>(
  GameRankListHttp,
  HttpSuccessType1,
)

export const GameRankListHS = MobXHttp<GameListQuery, PageResult<GameList>, null>(DWGameRankListHttp)
/*#endregion*/

/*#region 商品列表*/
const GamePromitionListHttp = BaseHttp<{ token?: string }, ApiResult<PromitionList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/gamePromitionList`,
})

const DWGamePromitionListHttp = DealWithHttp(GamePromitionListHttp, HttpSuccessType1)

export const GamePromitionListHS = MobXHttp<{ token?: string }, PromitionList[], null>(DWGamePromitionListHttp)
/*#endregion*/

/*#region 推荐游戏*/
const RecommendGameHttp = BaseHttp<RecommendGameQuery, ApiResult<PageResult<RecommendGame>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/recommendGame`,
})

const DWRecommendGameHttp = DealWithHttp(RecommendGameHttp, HttpSuccessType1)

export const RecommendGameHS = MobXHttp(DWRecommendGameHttp)
/*#endregion*/

/*#region 移除我的游戏*/
const RemoveMyGameHttp = BaseHttp<RemoveMyGameQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/removeMyGame`,
})

export const DWRemoveMyGameHttp = DealWithHttp(RemoveMyGameHttp, HttpSuccessType1)

/*#endregion*/

/*#region 获取游戏评论*/
const GetEvaluateListHttp = BaseHttp<PageQuery & TGetEvaluateListHttp, ApiResult<PageResult<EvaluateInfo>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getEvaluateList`,
})
const DWGetEvaluateListHttp = DealWithHttp(GetEvaluateListHttp, HttpSuccessType1)

export const GetEvaluateListHS = MobXHttp(DWGetEvaluateListHttp)
/*#endregion*/

/*#region 即将上线*/
const ComingGameHttp = BaseHttp<{ token?: string }, ApiResult<ComingGame[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/comming`,
})
const DWComingGameHttp = DealWithHttp(ComingGameHttp, HttpSuccessType1)

export const ComingGameHS = MobXHttp(DWComingGameHttp)
/*#endregion*/

/*#region 游戏预约*/
const SubscriptionGameHttp = BaseHttp<SubscriptionGameQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/gameRss`,
})

export const DWSubscriptionGameHttp = DealWithHttp(SubscriptionGameHttp, HttpSuccessType1)
/*#endregion*/

/*#region 我预约的游戏*/
const UserSubscriptionGameHttp = BaseHttp<UserSubscriptionGameQuery, ApiResult<PageResult<UserSubscriptionGame>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/myGameRss`,
})
const DWUserSubscriptionGameHttp = DealWithHttp(UserSubscriptionGameHttp, HttpSuccessType1)

export const UserSubscriptionGameHS = MobXHttp(DWUserSubscriptionGameHttp)
/*#endregion*/

/*#region 创建加速器订单*/
const CreateSpeedOrderHttp = BaseHttp<CreateSpeedOrderQuery, ApiResult<SpeedOrder>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createJsqOrder`,
})

const DWCreateSpeedOrderHttp = DealWithHttp(CreateSpeedOrderHttp, HttpSuccessType1)

export const CreateSpeedOrderHS = MobXHttp(DWCreateSpeedOrderHttp)
/*#endregion*/

/*#region 关闭通知窗口*/
const CloseNotifyHttp = BaseHttp<CloseNotifyQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/closeNotify`,
})

export const DWCloseNotifyHttp = DealWithHttp(CloseNotifyHttp, HttpSuccessType1)
/*#endregion*/

/*#region 启动加速器*/
const StartSpeedHttp = BaseHttp<LoginBaseQuery & { renew: 0 | 1 }, ApiResult<SpeedInfo>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/startJsq`,
})

export const DWStartSpeedHttp = DealWithHttp(StartSpeedHttp, HttpSuccessType1)
/*#endregion*/

/*#region 游戏工具合集*/
const GameToolListHttp = BaseHttp<GameToolListQuery, ApiResult<PageResult<GameTool>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/gameToolList`,
})
const DWGameToolListHttp = DealWithHttp(GameToolListHttp, HttpSuccessType1)

export const GameToolListHS = MobXHttp(DWGameToolListHttp)
/*#endregion*/

/*#region 游戏工具详情*/
const GameToolDetailHttp = BaseHttp<GameToolDetailQuery, ApiResult<GameToolDetail>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/gameToolDetail`,
})
const DWGameToolDetailHttp = DealWithHttp(GameToolDetailHttp, HttpSuccessType1)
export const GameToolDetailHS = MobXHttp(DWGameToolDetailHttp)
/*#endregion*/

/*#region 最近启动游戏*/
const RecentPlayGameHttp = BaseHttp<LoginBaseQuery, ApiResult<RecentPlayGame>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getRecentGame`,
})
const DWRecentPlayGameHttp = DealWithHttp(RecentPlayGameHttp, HttpSuccessType1)

export const RecentPlayGameHS = MobXHttp(DWRecentPlayGameHttp)
/*#endregion*/

/*#region 特惠游戏*/
const PromotionGameHttp = BaseHttp<PromotionGameQuery, ApiResult<Array<PromotionGame>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getPromotionGame`,
})

const DWPromotionGameHttp = DealWithHttp(PromotionGameHttp, HttpSuccessType1)

export const PromotionGameHS = MobXHttp(DWPromotionGameHttp)
/*#endregion*/

/*#region 限时秒杀游戏*/
const SecondKillGameHttp = BaseHttp<{ channel?: string }, ApiResult<TimeSpikeGame>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getSecondKillGame`,
})

const DWSecondKillGameHttp = DealWithHttp(SecondKillGameHttp, HttpSuccessType1)

export const SecondKillGameHS = MobXHttp(DWSecondKillGameHttp)
/*#endregion*/

/*#region 创建特惠游戏订单*/
const CreatePromotionOrderHttp = BaseHttp<CreatePromotionOrderQuery, ApiResult<CreateOrder>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createPromotionOrder`,
})

const DWCreatePromotionOrderHttp = DealWithHttp(CreatePromotionOrderHttp, HttpSuccessType1)

export const CreatePromotionOrderHS = MobXHttp(DWCreatePromotionOrderHttp)
/*#endregion*/

/*#region 检测特惠游戏订单支付状态*/
const CheckPromotionOrderHttp = BaseHttp<TStartGameQuery, ApiResult<CheckPromotionOrder>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/checkPromotionOrder`,
})

export const DWCheckPromotionOrderHttp = DealWithHttp(CheckPromotionOrderHttp, HttpSuccessType1)

export const CheckPromotionOrderHS = MobXHttp(DWCheckPromotionOrderHttp)
/*#endregion*/

/*#region 获取游戏存档*/
const GameArchiveHttp = BaseHttp<GameArchiveQuery, ApiResult2<GameArchive[]>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-common-cloud/anon/cloud/cd/list`,
})
export const DWGameArchiveHttp = DealWithHttp(GameArchiveHttp, HttpSuccessType2)
export const GameArchiveHS = MobXHttp(DWGameArchiveHttp)
/*#endregion*/

/*#region 删除存档*/
const DeleteGameArchiveHttp = BaseHttp<DeleteGameArchiveQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/deleteArchive`,
})
export const DWDeleteGameArchiveHttp = DealWithHttp(DeleteGameArchiveHttp, HttpSuccessType1)
/*#endregion*/

/*#region 根据启动订单查游戏详情*/
const GetGameDetailByOrderNoHttp = BaseHttp<TStartGameQuery, ApiResult<TgameName>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getUserOrderInfo`,
})
export const DWGetGameDetailByOrderNoHttp = DealWithHttp(GetGameDetailByOrderNoHttp, HttpSuccessType1)
/*#endregion*/

/*#region 获取游戏存档 MD5*/
const GetArchiveMD5Http = BaseHttp<{ key: string }, ApiResult2<string>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-common-cloud/anon/cloud/cd/keyMd5`,
})
export const DWGetArchiveMD5Http = DealWithHttp(GetArchiveMD5Http, HttpSuccessType2)
/*#endregion*/

/*#region 获取游戏启动详情数据*/
export const GamePlayInfoHttp = BaseHttp<GamePlayInfoQuery, ApiResult<GamePlayInfo>>({
  Type: 'Get',
  // Url: `${API_URL.BOX}/api/gamePlayAbout`,
  Url: `${API_URL.BOX_WEB}/api/gamePlayAbout`,
})

export const DWGamePlayInfoHttp = DealWithHttp(GamePlayInfoHttp, HttpSuccessType1)

export const GamePlayInfoHS = MobXHttp(DWGamePlayInfoHttp)
/*#endregion*/

/*#region 获取礼包合集*/
const GamePackageListHttp = BaseHttp<{ ids?: string; isAll?: number }, ApiResult<GamePackageList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/packGameList`,
})
export const DWGamePackageListHttp = DealWithHttp(GamePackageListHttp, HttpSuccessType1)

export const GamePackageListHS = MobXHttp(DWGamePackageListHttp)
/*#endregion*/

/*#region 获取礼包详情*/
const GamePackageDetailHttp = BaseHttp<{ id: number; token?: string }, ApiResult<GamePackageList>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/packGameDetail`,
})
export const DWGamePackageDetailHttp = DealWithHttp(GamePackageDetailHttp, HttpSuccessType1)
export const GamePackageDetailHS = MobXHttp(DWGamePackageDetailHttp)
/*#endregion*/

/*#region 创建礼包订单*/
const CreatePackageOrderHttp = BaseHttp<CreatePackageOrderQuery, ApiResult<CreatePackageOrderInfo>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createPackOrder`,
})

const DWCreatePackageOrderHttp = DealWithHttp(CreatePackageOrderHttp, HttpSuccessType1)

export const CreatePackageOrderHS = MobXHttp(DWCreatePackageOrderHttp)
/*#endregion */

/*#region 相关礼包*/
const RelatePackHttp = BaseHttp<RelatePackQuery, ApiResult<GamePackageList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getRelatePack`,
})

const DWRelatePackHttp = DealWithHttp(RelatePackHttp, HttpSuccessType1)

export const RelatePackHS = MobXHttp(DWRelatePackHttp)
/*#endregion*/

/*#region 游戏回收*/
const GameRecycleHttp = BaseHttp<GameRecycleQuery, ApiResult<{ Id: number }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/submitRecycle`,
})
export const DWGameRecycleHttp = DealWithHttp(GameRecycleHttp, HttpSuccessType1)
/*#endregion*/

/*#region 取消回收*/
const CancelRecycleHttp = BaseHttp<GameRecycleQuery, ApiResult<{ Id: number }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/cancelRecycle`,
})
export const DWCancelRecycleHttp = DealWithHttp(CancelRecycleHttp, HttpSuccessType1)
/*#endregion*/

/*#region 游戏回收状态*/
const GameRecycleStatusHttp = BaseHttp<GameRecycleStatusQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/checkRecycle`,
})
export const DWGameRecycleStatusHttp = DealWithHttp(GameRecycleStatusHttp, HttpSuccessType1)
/*#endregion*/

/*#region 游戏排行榜*/
const GameLeaderBoardHttp = BaseHttp<null, ApiResult<LeaderBoard[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/rankList`,
})
const DWGameLeaderBoardHttp = DealWithHttp(GameLeaderBoardHttp, HttpSuccessType1)

export const GameLeaderBoardHS = MobXHttp(DWGameLeaderBoardHttp)
/*#endregion*/

/*#region 申请退款*/
const orderRefund = BaseHttp<OrderRefundPayload, ApiResult<any>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/applyRefund`,
})

export const orderRefundHttp = DealWithHttp(orderRefund, HttpSuccessType1)

export const OrderRefundHS = MobXHttp(orderRefundHttp)
/*#endregion*/

/*#region 极速退款*/
const refundApply = BaseHttp<RefundApplyPayload, ApiResult2<RefundApplyResult>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/refund/apply`,
})
const DWrefundApplyHttp = DealWithHttp(refundApply, HttpSuccessType2)

export const DWrefundApplyHS = MobXHttp(DWrefundApplyHttp)
/*#endregion*/

/*#region 取消退款*/
const cancelRefund = BaseHttp<TtokenOrder, ApiResult<any>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/cancelRefund`,
})

export const cancelRefundHttp = DealWithHttp(cancelRefund, HttpSuccessType1)

export const CancelRefundHS = MobXHttp(cancelRefundHttp)
/*#endregion*/

/*#region 取消退款(java)*/
const cancelRefundJava = BaseHttp<TtokenOrder, ApiResult2<any>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/cancelRefund`,
})

export const cancelRefundJavaHttp = DealWithHttp(cancelRefundJava, HttpSuccessType2)

export const CancelRefundJavaHS = MobXHttp(cancelRefundJavaHttp)
/*#endregion*/

/*#region 提取账号资料 获取认证的二维码*/
const getExtractAccountQrcode = BaseHttp<{ token: string }, ApiResult<{ ticket: string; url: string }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/getDrawCode`,
})

export const getExtractAccountQrcodeHttp = DealWithHttp(getExtractAccountQrcode, HttpSuccessType1)

export const GetExtractAccountQrcodeHS = MobXHttp(getExtractAccountQrcodeHttp)
/*#endregion*/

/*#region 提取账号资料 检查二维码认证状态*/
const getExtractAccountCheckDrawCode = BaseHttp<{ token: string; ticket: string }, ApiResult<{ status: number }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/checkDrawCode`,
})

export const getExtractAccountCheckDrawCodeHttp = DealWithHttp(getExtractAccountCheckDrawCode, HttpSuccessType1)

export const GetExtractAccountCheckDrawCodeHS = MobXHttp(getExtractAccountCheckDrawCodeHttp)
/*#endregion*/

/*#region 提取账号资料 */
const applyAccountInfo = BaseHttp<TapplyAccountInfo, ApiResult<ExtractAccountInfo>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/applyAccountInfo`,
})

export const applyAccountInfoHttp = DealWithHttp(applyAccountInfo, HttpSuccessType1)

export const ApplyAccountInfoHS = MobXHttp(applyAccountInfoHttp)
/*#endregion*/

/*#region 线路满开始排队*/
const enterQueue = BaseHttp<TenterQueue, ApiResult<TenterQueueQuery>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/enterQueue`,
})

export const enterQueueHttp = DealWithHttp(enterQueue, HttpSuccessType1)

export const EnterQueueHS = MobXHttp(enterQueueHttp)
/*#endregion*/

/*#region 查询线路满排队状态*/
const queryQueue = BaseHttp<TQueuePayload, ApiResult<TqueryQueue>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/queryQueue`,
})

export const queryQueueHttp = DealWithHttp(queryQueue, HttpSuccessType1)

export const QueryQueueHS = MobXHttp(queryQueueHttp)
/*#endregion*/

/*#region 取消线路满排队*/
const cancelQueue = BaseHttp<TQueuePayload, ApiResult<TcancelQueue>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/cancelQueue`,
})

export const cancelQueueHttp = DealWithHttp(cancelQueue, HttpSuccessType1)

export const CancelQueueHS = MobXHttp(cancelQueueHttp)
/*#endregion*/

/*#region 排队超过30分钟 赠送礼物*/
const queueWelfare = BaseHttp<TtokenOrder, ApiResult<{ cdk: string }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/queueWelfare`,
})

export const queueWelfareHttp = DealWithHttp(queueWelfare, HttpSuccessType1)

export const QueueWelfareHS = MobXHttp(queueWelfareHttp)
/*#endregion*/

/*#region 会员推荐10款游戏列表*/
const vipGameList = BaseHttp<{ token: string }, ApiResult<any[]>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/vipGameList`,
})

export const vipGameListHttp = DealWithHttp(vipGameList, HttpSuccessType1)

export const VipGameListHS = MobXHttp(vipGameListHttp)
/*#endregion*/

/*#region 获取用户游戏禁封状态*/
const ForbidInfoHttp = BaseHttp<ForbidInfoQuery, ApiResult<ForbidInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getForbidInfo`,
})
export const DWForbidInfoHttp = DealWithHttp(ForbidInfoHttp, HttpSuccessType1)
export const ForbidInfoHS = MobXHttp(DWForbidInfoHttp)
/*@endregion*/

/*#region 获取保证金金额配置*/
const depositAmount = BaseHttp<{ gameId: number; channel?: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/anon/deposit/amount`,
})
export const DWdepositAmount = DealWithHttp(depositAmount, HttpSuccessType2)
export const depositAmountHS = MobXHttp(DWdepositAmount)
/*@endregion*/

/*#region 获取保证金详情 */
const depositDetail = BaseHttp<{ cashNo: string }, ApiResult3<Deposit>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/deposit/take/getByCashNo`,
})
export const DWDepositDetail = DealWithHttp(depositDetail, HttpSuccessType2)
/*@endregion*/

/*#region 提取保证金*/
const ApplyDepositHttp = BaseHttp<DepositQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/applyDeposit`,
})
export const DWApplyDepositHttp = DealWithHttp(ApplyDepositHttp, HttpSuccessType1)
/*#endr*/

/*#region 缴纳保证金*/
const ChargeDepositHttp = BaseHttp<ChargeDepositQuery, ApiResult<ChargeDeposit>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/chargeDeposit`,
})
const DWChargeDepositHttp = DealWithHttp(ChargeDepositHttp, HttpSuccessType1)
export const ChargeDepositHS = MobXHttp(DWChargeDepositHttp)
/*#region 获取订单的上号记录*/
export const loginGameRecord = BaseHttp<
  { orderNo: string },
  ApiResult3<{
    gameTime: null | number
    loginDays: null | number
    pager: {
      data: {
        loginTime: string
        playTime: number
        loginTimeS: number
      }[]
    } | null
  }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/refund/login/game/record`,
})
/*#endregion*/

/*#region 获取订单的上号记录*/
const GetRefundCodeHttp = BaseHttp<TtokenOrder, ApiResult<{ code: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getRefundCode`,
})
export const DWGetRefundCodeHttp = DealWithHttp(GetRefundCodeHttp, HttpSuccessType1)
/*#endregion*/

/*#region 获取退款配置*/
export const getRefundConfig = BaseHttp<TtokenOrder, ApiResult<TGetRefundConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getRefundConfig`,
})
/*#endregion*/

/*#region 计算退款金额*/
export const refundCalculate = BaseHttp<{ orderNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/refund/calculate`,
})
/*#endregion*/

/*#region 退款有异议*/
export const refundDissent = BaseHttp<
  { orderNo: string },
  ApiResult3<{ gameTime: null | number; loginDays: null | number; pager: null }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/refund/has/dissent`,
})
/*#endregion*/

/*#region 同意退款*/
export const refundConfirm = BaseHttp<
  { orderNo: string },
  ApiResult3<{ gameTime: null | number; loginDays: null | number; pager: null }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/refund/confirm`,
})
/*#endregion*/

/*#region 订单详情接口*/
const GetOrderInfoByNoHttp = BaseHttp<GetOrderInfoByNoQuery, ApiResult<GameOrder>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getOrderDetailByNo`,
})
export const DWGetOrderInfoByNoHttp = DealWithHttp(GetOrderInfoByNoHttp, HttpSuccessType1)
//export const GetOrderInfoByNoHS = MobXHttp(DWGetOrderInfoByNoHttp)
/*#endregion*/

/*#region 充值中心接口*/
const RechargeProductListHttp = BaseHttp<{ deliveryMethod?: 2 }, ApiResult<RechargeProductList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/rechargeProductList`,
})
const DWRechargeProductListHttp = DealWithHttp(RechargeProductListHttp, HttpSuccessType1)
export const RechargeProductListHS = MobXHttp(DWRechargeProductListHttp)
/*#endregion*/

/*#region 充值中心商品接口*/
const RechargeProductDetailHttp = BaseHttp<RechargeProductDetailQuery, ApiResult<RechargeProductDetail>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/rechargeProductDetail`,
})
const DWRechargeProductDetailHttp = DealWithHttp(RechargeProductDetailHttp, HttpSuccessType1)
export const RechargeProductDetailHS = MobXHttp(DWRechargeProductDetailHttp)
/*#endregion*/

/*#region 获取游戏平台字段*/
const getRechargeFieldHttp = BaseHttp<
  { platform: string; sqlNames?: string; colType?: number },
  ApiResult2<platformField>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/common/anon/game/platform/word/col/list`,
})
export const DWgetRechargeFieldHttp = DealWithHttp(getRechargeFieldHttp, HttpSuccessType2)

export const getRechargeFieldHs = MobXHttp(DWgetRechargeFieldHttp)
/*#endregion*/

/*#region 检测是否需要显示填写令牌 */
const getNeedFillToken = BaseHttp<{ account: string; pwd: string }, ApiResult2<string>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/game/account/check`,
})
export const DWgetNeedFillTokenHttp = DealWithHttp(getNeedFillToken, HttpSuccessType2)

export const getNeedFillTokenHs = MobXHttp(DWgetNeedFillTokenHttp)
/*#endregion*/

/*#region 获取修改订单弹框回显字段*/
const getRefillInfoHttp = BaseHttp<{ orderNo: string; token: string }, ApiResult<{ info: { [key: string]: string } }>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/orderInformation`,
})
export const DWgetRefillInfoHttp = DealWithHttp(getRefillInfoHttp, HttpSuccessType1)

export const getRefillInfoHs = MobXHttp(DWgetRefillInfoHttp)
/*#endregion*/

/*#region 保存修改订单信息*/
const setRefillInfoHttp = BaseHttp<{ orderNo: string; information: string; token?: string }, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/updateOrderExtend`,
})
export const DWsetRefillInfoHttp = DealWithHttp(setRefillInfoHttp, HttpSuccessType1)

export const setRefillInfoHs = MobXHttp(DWsetRefillInfoHttp)
/*#endregion*/

/*#region 保存修改订单信息*/
const setRefillInfoHttpNew = BaseHttp<{ orderNo: string; information: string; token?: string }, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/rewrite/allow/again`,
})
export const DWsetRefillInfoNewHttp = DealWithHttp(setRefillInfoHttpNew, HttpSuccessType1)

export const setRefillInfoNewHs = MobXHttp(DWsetRefillInfoNewHttp)
/*#endregion*/

/*#region 通过商品 Id 获取商品价格*/
const GetGoodPriceByIdHttp = BaseHttp<GoodPriceByIdQuery, ApiResult<{ [key: string]: SpeedGoodsBuyId }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/goods/list/info/ext`,
})
export const DWGetGoodPriceByIdHttp = DealWithHttp(GetGoodPriceByIdHttp, HttpSuccessType1)
export const GetGoodPriceByIdHS = MobXHttp(DWGetGoodPriceByIdHttp)
/*#endregion*/

/*#region 再次充值接口*/
const RechargeAgainHttp = BaseHttp<RechargeAgainQuery, ApiResult<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/rechargeAgain`,
})
export const DWRechargeAgainHttpHttp = DealWithHttp(RechargeAgainHttp, HttpSuccessType1)
export const RechargeAgainHttpHS = MobXHttp(DWRechargeAgainHttpHttp)
/*#endregion*/

/*#region 再次充值接口*/
const ApplyUnblockHttp = BaseHttp<ApplyUnblockQuery, ApiResult<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/applyUnblock`,
})
export const DWApplyUnblockHttp = DealWithHttp(ApplyUnblockHttp, HttpSuccessType1)
export const ApplyUnblockHttpHS = MobXHttp(DWApplyUnblockHttp)
/*#endregion*/

/*#region 取消申诉 */
const cancelComplaintHttp = BaseHttp<{ userGameId: number }, ApiResult3<boolean>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/cancel/complaint`,
})
export const DWCancelComplaintHttp = DealWithHttp(cancelComplaintHttp, HttpSuccessType2)
/*#endregion*/

/*#region 神秘商店抽取折扣*/
const ExtractDiscountHttp = BaseHttp<LoginBaseQuery, ApiResult<{ discount: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/extractDiscount`,
})
export const DWExtractDiscountHttp = DealWithHttp(ExtractDiscountHttp, HttpSuccessType1)
export const ExtractDiscountHS = MobXHttp(DWExtractDiscountHttp)
/*#endregion*/

/*#region 购买神秘商店抽奖次数*/
const CreateLotteryOrderHttp = BaseHttp<CreateLotteryOrderQuery, ApiResult<CreateLotteryOrder>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createLotteryOrder`,
})
export const DWCreateLotteryOrderHttp = DealWithHttp(CreateLotteryOrderHttp, HttpSuccessType1)
export const CreateLotteryOrderHS = MobXHttp(DWCreateLotteryOrderHttp)
/*#endregion*/

/*#region 获取vip客服服务商品*/
const VipServiceHttp = BaseHttp<
  VipServiceQuery,
  ApiResult3<{ id: number; productName: string; price: number; serviceContent: Array<string>; saleNum: number }[]>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/get/service/goods/list`,
})
const DWVipServiceHttp = DealWithHttp(VipServiceHttp, HttpSuccessType2)
export const VipServiceHS = MobXHttp(DWVipServiceHttp)
/*#endregion*/

/*#region 获取活动价格 */
const getActivityPrice = BaseHttp<
  { activityType: string },
  ApiResult2<{ forever: number; expe: number; season: number; year: number; month?: number }>
>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/anon/box/vip/price/get` })
const DWgetActivityPriceHttp = DealWithHttp(getActivityPrice, HttpSuccessType2)
export const getActivityPriceHS = MobXHttp(DWgetActivityPriceHttp)
/*#endregion*/

/*#region vip客服服务评价*/
const serviceEvaluation = BaseHttp<ServiceEvaluationQuery, ApiResult3<string>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/serviceEvaluation`,
})
const serviceEvaluationHttp = DealWithHttp(serviceEvaluation, HttpSuccessType2)
export const serviceEvaluationHS = MobXHttp(serviceEvaluationHttp)
/*#endregion*/

/*#region 获取天卡升级永久的活动价格 */
const getVipPrice = BaseHttp<
  { activityType: 'expeUpForever' },
  ApiResult2<{ forever: number; expe: number; year: number }>
>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/anon/box/vip/price/get` })
const DWgetVipPriceHttp = DealWithHttp(getVipPrice, HttpSuccessType2)
export const getVipPriceHS = MobXHttp(DWgetVipPriceHttp)
/*#endregion*/

/*#region 获取当前用户是否已经抽奖 */
const isLotteryBeenDraw = BaseHttp<
  { token: string },
  ApiResult2<{ isCanLottery: number; isBeenLottery: number; distanceActivityEndTime: number }>
>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/api/isLotteryBeenDraw` })
const DWisLotteryBeenDrawHttp = DealWithHttp(isLotteryBeenDraw, HttpSuccessType2)
export const isLotteryBeenDrawHS = MobXHttp(DWisLotteryBeenDrawHttp)
/*#endregion*/

/*#region 获取当前用户是否已经抽奖 */
const lotteryBeenDraw = BaseHttp<{ token: string }, ApiResult2<{ token: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/lotteryDraw`,
})
const DWlotteryBeenDrawHttp = DealWithHttp(lotteryBeenDraw, HttpSuccessType2)
export const lotteryBeenDrawHS = MobXHttp(DWlotteryBeenDrawHttp)
/*#endregion*/

/*#region 获取当前用户是否已经抽奖 */
const getWinningList = BaseHttp<
  { token: string },
  ApiResult2<{ mobile: string; isWinPrize: number; winPrizeType: string }[]>
>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/api/winningList` })
const DWgetWinningListHttp = DealWithHttp(getWinningList, HttpSuccessType2)
export const getWinningListHS = MobXHttp(DWgetWinningListHttp)
/*#endregion*/

/*#region 获取9+1配置 */
const getActive1Config = BaseHttp<{ activityType: 'nine_one' }, ApiResult2<{ joinNum: string; lastTime: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/activity/info`,
})
const DWgetActive1ConfigHttp = DealWithHttp(getActive1Config, HttpSuccessType2)
export const getActive1ConfigHS = MobXHttp(DWgetActive1ConfigHttp)
/*#endregion*/

/*#region 获取游戏存档列表 */
const getGameArchiveList = BaseHttp<
  { gameLibraryId?: number; relationGameId?: number; pageNo: number; pageSize: number; accountType: 33; sort?: 'new' },
  ApiResult<PageResult<GameList>>
>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/api/gpGameList` })
const DWgetGameArchiveListHttp = DealWithHttp(getGameArchiveList, HttpSuccessType1)
export const getGameArchiveListHS = MobXHttp(DWgetGameArchiveListHttp)
/*#endregion*/

/*#region 获取当前游戏库下的支持云游戏的游戏列表 */
const getCloudGameList = BaseHttp<
  { gameLibraryId: string; accountType: 1; supportCloudGame: true; isDefault: 0 },
  ApiResult<PageResult<GameList>>
>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/api/gpGameList` })
const DWgetCloudGameList = DealWithHttp(getCloudGameList, HttpSuccessType1)
export const getCloudGameListHS = MobXHttp(DWgetCloudGameList)
/*#endregion*/

/*#region 获取游戏库列表 */
const getGameLibraryList = BaseHttp<GetGameLibraryListPayload, ApiResult3<GameLibraryGame[]>>({
  Type: 'Post',
  // Url: `${API_URL.BOX_WEB}/api/my/gameLibraryList`,
  Url: `${API_URL.BOX_WEB}/user/gameLibrary/list`,
})
const DWgetGameLibraryListHttp = DealWithHttp(getGameLibraryList, HttpSuccessType2)
export const getGameLibraryListHS = MobXHttp(DWgetGameLibraryListHttp)
/*#endregion*/

/*#region 通过游戏库id获取账号列表 */
const getAccountListByGameLibraryId = BaseHttp<
  GetAccountListByGameLibraryIdPayload,
  ApiResult3<GetAccountListByGameLibraryIdResult>
>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/api/my/gameLibrary/selectAccount` })
const DWgetAccountListByGameLibraryIdHttp = DealWithHttp(getAccountListByGameLibraryId, HttpSuccessType2)
export const getAccountListByGameLibraryIdHS = MobXHttp(DWgetAccountListByGameLibraryIdHttp)
/*#endregion*/

/*#region 存档详情*/
const archiveInfoHttp = BaseHttp<TarchiveInfoHttp, ApiResult<GameDetail>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/gameDivision`,
})

export const DWarchiveInfoHttp = DealWithHttp(archiveInfoHttp, HttpSuccessType1)

export const archiveInfoHS = MobXHttp(DWarchiveInfoHttp)
/*#endregion*/

/*#region 用户历史搜索前6查询*/
const getUserLastListHttp = BaseHttp<{ token: string }, ApiResult<SearchGameType[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/goods/search/his/getUserLastList`,
})

export const DWgetUserLastListHttp = DealWithHttp(getUserLastListHttp, HttpSuccessType1)

export const getUserLastListHS = MobXHttp(DWgetUserLastListHttp)
/*#endregion*/

/*#region 获取进程名*/
const getProcessNameByOrder = BaseHttp<{ orderNo: string }, ApiResult2<TGetProcessNameByOrderResult>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-common-cloud/anon/cloudSave/config/getByOrder`,
})

export const DWgetProcessNameByOrderHttp = DealWithHttp(getProcessNameByOrder, HttpSuccessType2)

export const getProcessNameByOrderHS = MobXHttp(DWgetProcessNameByOrderHttp)
/*#endregion*/

/*#region 用户想玩游戏反馈*/
const wantPlayByFeedback = BaseHttp<{ content: string; token: string; channel: string }, ApiResult<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/wantPlayByFeedback`,
})

export const DWwantPlayByFeedback = DealWithHttp(wantPlayByFeedback, HttpSuccessType1)

export const wantPlayByFeedbackHS = MobXHttp(DWwantPlayByFeedback)
/*#endregion*/

/*#region 用户历史搜索上报(登录后上报)*/
const saveSearchHis = BaseHttp<
  { goodsId: number; userId: number; searchKey: string; goodsName?: string },
  ApiResult2<null>
>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/goods/search/his/saveSearchHis`,
})
const DWsaveSearchHis = DealWithHttp(saveSearchHis, HttpSuccessType2)

export const saveSearchHisHS = MobXHttp(DWsaveSearchHis)
/*#endregion*/

/*#region 热门搜索上报(登录前后都要上报)*/
const saveSearchHot = BaseHttp<{ goodsId: number; userId?: string; goodsName?: string }, ApiResult2<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/goods/search/hot/saveSearchHot`,
})
const DWsaveSearchHot = DealWithHttp(saveSearchHot, HttpSuccessType2)

export const saveSearchHotHS = MobXHttp(DWsaveSearchHot)
/*#endregion*/

/*#region 删除用户搜索历史*/
const deleteSearchHis = BaseHttp<{ userId: number; searchKey: string; token: string }, ApiResult<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/goods/his/deleteSearchHis`,
})

export const DWdeleteSearchHis = DealWithHttp(deleteSearchHis, HttpSuccessType1)

export const deleteSearchHisHS = MobXHttp(DWdeleteSearchHis)
/*#endregion*/

/*#region 热门搜索前6查询*/
const getHotList = BaseHttp<{}, ApiResult<SearchGameType[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/goods/search/hot/getHotList`,
})

export const DWgetHotList = DealWithHttp(getHotList, HttpSuccessType1)

export const getHotListHS = MobXHttp(DWgetHotList)
/*#endregion*/

/*#region 语言筛选项*/
const getLanguageHttp = BaseHttp<{ sqlName: string }, ApiResult2<{ text: string; val: string }[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/common/anon/col/values`,
})

export const DWGetLanguage = DealWithHttp(getLanguageHttp, HttpSuccessType2)

export const getLanguageHS = MobXHttp(DWGetLanguage)
/*#endregion*/

/*#region 获取抽奖次数*/
const getReveiceLotteryNumList = BaseHttp<{}, ApiResult2<TGetReveiceLotteryNumList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/need/getReveiceLotteryNumList`,
})

export const DWgetReveiceLotteryNumList = DealWithHttp(getReveiceLotteryNumList, HttpSuccessType2)

export const getReveiceLotteryNumListHS = MobXHttp(DWgetReveiceLotteryNumList)
/*#endregion*/

/*#region 获取活动相关信息*/
const getActivityConfigInfoHttp = BaseHttp<{ activityNo: string }, ApiResult2<TGetActivityConfigInfoHS>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/activityConfigInfo`,
})

export const DWGetActivityConfigInfo = DealWithHttp(getActivityConfigInfoHttp, HttpSuccessType2)

export const getActivityConfigInfoHS = MobXHttp(DWGetActivityConfigInfo)
/*#endregion*/

/*#region 获取用户是否购买过中秋活动天卡 */
const getIsBuyedVipExpeByZhongQiuActivity = BaseHttp<{ activityNo: string; vipType: string }, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getIsBuyedVipExpeByZhongQiuActivity`,
})

export const DWgetIsBuyedVipExpeByZhongQiuActivity = DealWithHttp(getIsBuyedVipExpeByZhongQiuActivity, HttpSuccessType2)

export const getIsBuyedVipByActivityHS = MobXHttp(DWgetIsBuyedVipExpeByZhongQiuActivity)
/*#endregion*/

/*#region 领取抽奖次数*/
const reveiceLotteryNumHttp = BaseHttp<{}, ApiResult2<TGetReveiceLotteryNumList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/reveice/lotteryNum`,
})

export const DWreveiceLotteryNumHttp = DealWithHttp(reveiceLotteryNumHttp, HttpSuccessType2)

export const reveiceLotteryNumHS = MobXHttp(DWreveiceLotteryNumHttp)
/*#endregion*/

/*#region 获取捆绑加速器的加速器商品信息*/
const getBundledJsqHttp = BaseHttp<{}, ApiResult2<TGetBundledJsqHttp>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getBundledJsq`,
})

export const DWgetBundledJsqHttp = DealWithHttp(getBundledJsqHttp, HttpSuccessType2)

export const getBundledJsqHS = MobXHttp(DWgetBundledJsqHttp)
/*#endregion*/

/*#region 判断是不是新用户*/
const getIsNewUserHttp = BaseHttp<{}, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/noOrder`,
})

export const DWgetIsNewUserHttp = DealWithHttp(getIsNewUserHttp, HttpSuccessType2)

export const getIsNewUserHS = MobXHttp(DWgetIsNewUserHttp)
/*#endregion*/

/*#region 获取PUBG列表分类*/
const getPUBGTabsMapping = BaseHttp<{}, ApiResult2<any[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/common/anon/col/values`,
})

export const DWgetPUBGTabsMapping = DealWithHttp(getPUBGTabsMapping, HttpSuccessType2)

export const getPUBGTabsMappingHS = MobXHttp(DWgetPUBGTabsMapping)
/*#endregion*/

/*#region 获取加速器区服配置*/
const getAreaListHttp = BaseHttp<{ gameId: number }, ApiResult2<JsqAreaInfo[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/speedArea/getAreaList`,
})

export const DWgetAreaListHttp = DealWithHttp(getAreaListHttp, HttpSuccessType2)

export const getAreaListHS = MobXHttp(DWgetAreaListHttp)
/*#endregion*/

/*#region 通过APPID获取gameLibrary对象*/
const getGameLibraryByAppId = BaseHttp<{ appid: number | string }, ApiResult2<GameLibraryGame>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/gameid/get/by/appid`,
})

export const DWgetGameLibraryByAppId = DealWithHttp(getGameLibraryByAppId, HttpSuccessType2)

export const getGameLibraryByAppIdHS = MobXHttp(DWgetGameLibraryByAppId)
/*#endregion*/

/*#region 云游戏-获取用户云游戏剩余可用时长*/
const getCloudInfoHttp = BaseHttp<{ realTime?: boolean }, ApiResult3<TCloudInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/user/game/cloud/info`,
})

export const DWgetCloudInfoHttp = DealWithHttp(getCloudInfoHttp, HttpSuccessType2)

export const getCloudInfoHS = MobXHttp(DWgetCloudInfoHttp)
/*#endregion*/

/*#region 云游戏-查询云游戏时长商品列表*/
const getCloudGoodsListHttp = BaseHttp<{}, ApiResult3<TCloudGoodsList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/get/cloud/game/goods/list`,
})

export const DWgetCloudGoodsListHttp = DealWithHttp(getCloudGoodsListHttp, HttpSuccessType2)

export const getCloudGoodsListHS = MobXHttp(DWgetCloudGoodsListHttp)
/*#endregion*/

/*#region 云游戏-查询用户云游戏变更时长记录列表*/
const getCloudTimeChangeHttp = BaseHttp<TqueryCloudTimeChange, ApiResult3<WithPages<TCloudTimeChangeList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/user/game/cloud/time/change`,
})

export const DWgetCloudTimeChangeHttp = DealWithHttp(getCloudTimeChangeHttp, HttpSuccessType2)

export const getCloudTimeChangeHS = MobXHttp(DWgetCloudTimeChangeHttp)
/*#endregion*/

/*#region 用户领取记录*/
const getUserReceiveList = BaseHttp<
  {
    activityNo: string
    lastDayType: number
    pageNo: number
    pageSize: number
  },
  ApiResult3<WithPages<TReceiveInfo>>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/user/received/list`,
})

export const DWgetUserReceiveList = DealWithHttp(getUserReceiveList, HttpSuccessType2)

export const getUserReceiveListHS = MobXHttp(DWgetUserReceiveList)
/*#endregion*/

/*#region 获取游戏上号配置*/
const getPlayGameConfigHttp = BaseHttp<{ gameId: number }, ApiResult3<TPlayGameConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/get/playgameConfig`,
})

export const DWgetPlayGameConfigHttp = DealWithHttp(getPlayGameConfigHttp, HttpSuccessType2)

export const getPlayGameConfigHS = MobXHttp(DWgetPlayGameConfigHttp)
/*#endregion*/

/*#region 增加游戏上号配置*/
const addPlayGameConfig = BaseHttp<TPlayGameConfig, ApiResult2<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/add/playgameConfig`,
})
const DWaddPlayGameConfig = DealWithHttp(addPlayGameConfig, HttpSuccessType2)

export const addPlayGameConfigHS = MobXHttp(DWaddPlayGameConfig)
/*#endregion*/

/** #region 查询当前用户游戏状态 */
const getUserGameStatus = BaseHttp<null, ApiResult2<TUserGameStatus>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/current/game/play/status`,
})
export const DWgetUserGameStatus = DealWithHttp(getUserGameStatus, HttpSuccessType2)

export const getUserGameStatusHS = MobXHttp(DWgetUserGameStatus)
/*#endregion*/

/*#region 修改云存档名称*/
const updateName = BaseHttp<{ name: string; userId: string; id: number }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.ORIGIN}/fulu-common-cloud/anon/cloud/saveLog/updateName`,
})
const DWupdateName = DealWithHttp(updateName, HttpSuccessType2)

export const updateNameHS = MobXHttp(DWupdateName)
/*#endregion*/

/*#region 获取游戏上号配置*/
const operationCollection = BaseHttp<{ gameLibraryId: number; action: 1 | 0 }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/operation/collection`,
})

export const DWoperationCollection = DealWithHttp(operationCollection, HttpSuccessType2)

export const operationCollectionHS = MobXHttp(DWoperationCollection)
/*#endregion*/

/*#region 通过游戏id获取礼包列表*/
const getGiftPackageListByGameId = BaseHttp<{ gameId: number }, ApiResult3<GamePackageList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/list/packs/by/gameId`,
})

export const DWgetGiftPackageListByGameId = DealWithHttp(getGiftPackageListByGameId, HttpSuccessType2)

export const getGiftPackageListByGameIdHS = MobXHttp(DWgetGiftPackageListByGameId)
/*#region 是否显示R星游戏帮助弹框*/
const isShowStartGameHelp = BaseHttp<{ gameId: string }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/isShowStartGameHelp`,
})

export const DWisShowStartGameHelp = DealWithHttp(isShowStartGameHelp, HttpSuccessType2)

export const isShowStartGameHelpHS = MobXHttp(DWisShowStartGameHelp)
/*#endregion*/

/*#region 查询敏感词信息*/
const getByWord = BaseHttp<{ word: string }, ApiResult3<TSensitiveWord | null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/sensitiveWord/anon/getByWord`,
})

export const DWgetByWord = DealWithHttp(getByWord, HttpSuccessType2)
/*#endregion*/

/*#region 获取用户未使用优惠券总金额*/
const getCouponTotalAmt = BaseHttp<{}, ApiResult3<number | null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/valid/coupon/reduct/amt/total/get`,
})

export const DWgetCouponTotalAmt = DealWithHttp(getCouponTotalAmt, HttpSuccessType2)
/*#endregion*/

/*#region 获取用户是否有订单*/
const getUserHasOrder = BaseHttp<
  { isList?: boolean },
  ApiResult3<{ all: boolean; exchange: boolean; upgrade: boolean }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/order/query/hasOrder`,
})

export const DWgetUserHasOrder = DealWithHttp(getUserHasOrder, HttpSuccessType2)
export const getUserHasOrderHS = MobXHttp(DWgetUserHasOrder)
/*#endregion*/

/*#region 通过商品id获取游戏库详情*/
const getGameLibraryInfoByGoodsId = BaseHttp<{ goodsId: number }, ApiResult3<{ gameLibraryId: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/goods/info`,
})

export const DWGetGameLibraryInfoByGoodsId = DealWithHttp(getGameLibraryInfoByGoodsId, HttpSuccessType2)
/*#endregion*/

/*#region 特价专区配置*/
const getBargainConfig = BaseHttp<{}, ApiResult3<TgetBargainConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/bargain/price/config/get`,
})

export const DWgetBargainConfig = DealWithHttp(getBargainConfig, HttpSuccessType2)
/*#endregion*/

/*#region 存档详情*/
const getArchiveDetail = BaseHttp<{ id: number }, ApiResult3<TGamelibraryArchives>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/archives/goods/get/by/id`,
})

export const DWgetArchiveDetail = DealWithHttp(getArchiveDetail, HttpSuccessType2)

export const getArchiveDetailHS = MobXHttp(DWgetArchiveDetail)
/*#endregion*/

/*#region 游戏库分页查询*/
const getGamelibraryGoodsList = BaseHttp<TGameLibraryListPayload, ApiResult3<PageResult<TGameLibraryListResult>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/game/library/search`,
})

export const DWgetGamelibraryGoodsList = DealWithHttp(getGamelibraryGoodsList, HttpSuccessType2)

export const getGamelibraryGoodsListHS = MobXHttp(DWgetGamelibraryGoodsList)
/*#endregion*/

/*#region 游戏库分页查询*/
const idleAccountSharing = BaseHttp<
  { mobile: string; qq: string; content: string },
  ApiResult3<PageResult<TGameLibraryListResult>>
>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/idleAccount/sharing`,
})

export const DWidleAccountSharing = DealWithHttp(idleAccountSharing, HttpSuccessType2)

export const idleAccountSharingHS = MobXHttp(DWidleAccountSharing)
/*#endregion*/

/*#region 游戏库分页查询*/
const idleAccountSharingStatistics = BaseHttp<{ gameLibraryId: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/idleAccount/sharing/statistics`,
})

export const DWidleAccountSharingStatistics = DealWithHttp(idleAccountSharingStatistics, HttpSuccessType2)

export const idleAccountSharingStatisticsHS = MobXHttp(DWidleAccountSharingStatistics)
/*#region 存档详情*/
const userGameLibraryRemove = BaseHttp<
  { userGameId?: number; gameLibraryId?: number },
  ApiResult3<TGamelibraryArchives>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/gameLibrary/remove`,
})

export const DWuserGameLibraryRemove = DealWithHttp(userGameLibraryRemove, HttpSuccessType2)

export const userGameLibraryRemoveHS = MobXHttp(DWuserGameLibraryRemove)
/*#endregion*/
/*#region 活动页启动游戏前获取用户游戏库id*/
const systemDistriUserGameId = BaseHttp<{ gameId: number; activityNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/activity/systemDistriUserGameId`,
})

export const getsystemDistriUserGameId = DealWithHttp(systemDistriUserGameId, HttpSuccessType2)
/*#endregion*/

/** 获取直播间秒杀商品 */
const secondsKillGoodsList = BaseHttp<{ activityNo: string }, ApiResult3<TseckillGame[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/seconds/kill/goodsList`,
})

export const getSecondsKillGoodsList = DealWithHttp(secondsKillGoodsList, HttpSuccessType2)

/** 获取直播间秒杀时间 */
const secondsKillTime = BaseHttp<{ activityNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/seconds/kill/time`,
})

export const getsecondsKillTime = DealWithHttp(secondsKillTime, HttpSuccessType2)

/** 判断直播秒杀商品活动状态 */
const secondsKillActivityStatus = BaseHttp<{ activityNo: string }, ApiResult3<string>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/activityInfo`,
})

export const checkSecondsKillActivityStatus = DealWithHttp(secondsKillActivityStatus, HttpSuccessType2)

/*#region 根据游戏库ID获取所属游戏库的汉化包*/
const getChinesePackageList = BaseHttp<{ gameLibraryId: number }, ApiResult3<IChinesePackage[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/game/chinesization/pack/list`,
})

export const DWgetChinesePackageList = DealWithHttp(getChinesePackageList, HttpSuccessType2)

export const getChinesePackageListHS = MobXHttp(DWgetChinesePackageList)
/*#endregion*/

/*#region 根据游戏库ID获取所属游戏库的MOD商品*/
const getMODList = BaseHttp<{ gameLibraryId?: number; goodsIds?: string }, ApiResult3<IChinesePackage[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/game/mod/list`,
})

export const DWgetMODList = DealWithHttp(getMODList, HttpSuccessType2)

export const getMODListHS = MobXHttp(DWgetMODList)
/*#endregion*/

/*#region 根据游戏(库)ID获取游戏MOD配置信息*/
const getGameMODConfig = BaseHttp<{ gameId: number }, ApiResult3<TMODConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/game/mod/config`,
})

export const DWgetGameMODConfig = DealWithHttp(getGameMODConfig, HttpSuccessType2)

export const getGameMODConfigHS = MobXHttp(DWgetGameMODConfig)
/*#endregion*/

/*#region 根据游戏库ID获取所属游戏库的MOD商品(排除了用户已拥有的，并且排序)*/
const getMODBundlesList = BaseHttp<{ goodsIds: string }, ApiResult3<IChinesePackage[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/game/mod/bundles`,
})

export const DWgetMODBundlesList = DealWithHttp(getMODBundlesList, HttpSuccessType2)

export const getMODBundlesListHS = MobXHttp(DWgetMODBundlesList)
/*#endregion*/

/*#region 获取用户存档列表*/
const getUserArchiveList = BaseHttp<{}, ApiResult3<TGamelibraryArchives[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/user/knapsack/archives`,
})

export const DWgetUserArchiveList = DealWithHttp(getUserArchiveList, HttpSuccessType2)

export const getUserArchiveListHS = MobXHttp(DWgetUserArchiveList)
/*#endregion*/
/*#region 取用户MOD列表*/
const getUserMODList = BaseHttp<{}, ApiResult3<IChinesePackage[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/user/knapsack/mods`,
})

export const DWgetUserMODList = DealWithHttp(getUserMODList, HttpSuccessType2)

export const getUserMODListHS = MobXHttp(DWgetUserMODList)
/*#endregion*/
/*#region 获取用户汉化包列表*/
const getUserChinesizationsList = BaseHttp<{}, ApiResult3<IChinesePackage[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/user/knapsack/chinesizations`,
})

export const DWgetUserChinesizationsList = DealWithHttp(getUserChinesizationsList, HttpSuccessType2)

export const getUserChinesizationsListHS = MobXHttp(DWgetUserChinesizationsList)
/*#endregion*/

/*#region 获取汉化包下载地址 */
const getChinesePackageDownloadUrl = BaseHttp<{ goodsId: number }, ApiResult3<string>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/game/chinesization/pack/download/url`,
})

export const DWgetChinesePackageDownloadUrl = DealWithHttp(getChinesePackageDownloadUrl, HttpSuccessType2)
/*#endregion*/

/*#region 获取MOD下载地址 */
const getMODDownloadUrl = BaseHttp<{ goodsId: number }, ApiResult3<string>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/game/mod/download/url`,
})

export const DWgetMODDownloadUrl = DealWithHttp(getMODDownloadUrl, HttpSuccessType2)
/*#endregion*/

/*#region 汉化包下载上报 */
export const reportChinesePackageDownload = BaseHttp<{ goodsId: number }, ApiResult3<string>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/game/chinesization/pack/download/report`,
})
/*#endregion*/

/*#region MOD下载上报 */
export const reportMODDownload = BaseHttp<{ goodsId: number }, ApiResult3<string>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/game/mod/download/report`,
})
/*#endregion*/

/*#region 汉化包详情*/
const getChinesePackageDetail = BaseHttp<{ goodsId: number }, ApiResult3<IChinesePackage>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/game/chinesization/pack/get`,
})

export const DWgetChinesePackageDetail = DealWithHttp(getChinesePackageDetail, HttpSuccessType2)

export const getChinesePackageDetaillHS = MobXHttp(DWgetChinesePackageDetail)
/*#endregion*/

/*#region MOD详情*/
const getMODDetail = BaseHttp<{ goodsId: number }, ApiResult3<IChinesePackage>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/game/mod/get`,
})

export const DWgetMODDetail = DealWithHttp(getMODDetail, HttpSuccessType2)

export const getMODDetaillHS = MobXHttp(DWgetMODDetail)
/*#endregion*/

/*#region 获取渠道分组 */
const getChannelGroup = BaseHttp<{ channel: string }, ApiResult3<IChanelGroup>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/channel/group/info`,
})
export const DWGetChannelGroup = DealWithHttp(getChannelGroup, HttpSuccessType2)
export const getChannelGroupHS = MobXHttp(DWGetChannelGroup)
/*#endregion*/

/** 根据游戏库ID获取第三方修改器信息 */
const modifierDetailById = BaseHttp<{ gameLibraryId: number }, ApiResult3<TmodifierDetail>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/trainer/info/get/by/gamelibraryid`,
})
export const getModifierDetailById = DealWithHttp(modifierDetailById, HttpSuccessType2)

/**
 * 废弃接口
 */
/*#region 获取每日秒杀游戏*/
// const DailySpikeGamesHttp = BaseHttp<{ token?: string }, ApiResult<DailySpikeGame[]>>({
//   Type: 'Get',
//   Url: `${API_URL.BOX}/api/getSaleGame`,
// })
// const DWDailySpikeGames = DealWithHttp(DailySpikeGamesHttp, HttpSuccessType1)

// export const DailySpikeGamesHS = MobXHttp(DWDailySpikeGames)
/*#endregion*/
